module.exports = __webpack_public_path__ + "static/img/花卉种子仓库管理软件.05982d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/花卉种子仓库管理软件.jpg
// module id = 9TkB
// module chunks = 15